/**
 * Định dạng số thành chuỗi tiền tệ
 * VD: (VND: 1000000 -> 1.000.000) | (USD: 1500.5 -> 1,500.5)
 */
export const formatCurrency = (value, currency = 'VND') => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';

    if (currency === 'USD') {
        // Định dạng USD: Dấu phẩy ngăn cách nghìn, dấu chấm cho số thập phân (tối đa 2 số thập phân)
        return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
    
    // Định dạng VND mặc định: Dấu chấm ngăn cách nghìn, không có số thập phân
    return parseInt(num).toLocaleString('vi-VN');
};

/**
 * Chuyển chuỗi tiền tệ đã format về số thực/số nguyên để tính toán
 */
export const parseCurrency = (formattedValue, currency = 'VND') => {
    if (formattedValue === null || formattedValue === undefined || formattedValue === '') return 0;
    const strValue = formattedValue.toString();

    if (currency === 'USD') {
        // Xóa dấu phẩy (phân cách hàng nghìn US), giữ lại dấu chấm thập phân
        const rawValue = strValue.replace(/,/g, '').replace(/[^0-9.-]/g, '');
        return parseFloat(rawValue) || 0;
    }

    // VND: Xóa tất cả dấu chấm và ký tự không phải số
    const rawValue = strValue.replace(/\./g, '').replace(/[^0-9-]/g, '');
    return parseInt(rawValue) || 0;
};